import {
	UPLOADED_FILES_TABLE_SECTION_I18N_KEYS
} from '../../../../../features/topics/components/constants/i18n/UploadedFilesTableSectioni18nConstants';

export const UPLOADED_FILES_TABLE_SECTION_I18N_EN = {
	[UPLOADED_FILES_TABLE_SECTION_I18N_KEYS.title]:              "Uploaded Files",
	[UPLOADED_FILES_TABLE_SECTION_I18N_KEYS.file_name]:          "File name",
	[UPLOADED_FILES_TABLE_SECTION_I18N_KEYS.file_size]:          "File size",
    [UPLOADED_FILES_TABLE_SECTION_I18N_KEYS.file_language]:      "Language",
    [UPLOADED_FILES_TABLE_SECTION_I18N_KEYS.file_date_uploaded]: "Date Uploaded",
	[UPLOADED_FILES_TABLE_SECTION_I18N_KEYS.file_status]:        "Status",
	[UPLOADED_FILES_TABLE_SECTION_I18N_KEYS.kb_label]:           "{{fileSizeInKB}} KB"
};



// WEBPACK FOOTER //
// ./src/locales/en/features/topics/components/uploaded_files_table_section.i18n.en.js